import React from 'react';
import { HtmlParser } from 'components/common';
import { string } from 'prop-types';
import './LongDisclaimer.scss';

const LongDisclaimer = ({ long }) => (
  <p className="tiLongDisclaimer">
    <HtmlParser htmlString={long} />
  </p>
);

LongDisclaimer.propTypes = {
  long: string,
};

export default LongDisclaimer;
